import React from 'react';

const SvgTimer300Selected = props => (
	<svg width={40} height={40} {...props}>
		<text
			fill="#FDFDFE"
			fillRule="evenodd"
			fontFamily="Roboto-Medium, Roboto"
			fontSize={15}
			fontWeight={400}
			opacity={0.4}
		>
			<tspan x={5.723} y={25}>
				{'3:00'}
			</tspan>
		</text>
	</svg>
);

export default SvgTimer300Selected;
